export default {
  "APP_COMMERCE_VIEW": "APP_COMMERCE_VIEW",
  "APP_PRODUCT_IDENTIFIER_UPDATE":"APP_PRODUCT_IDENTIFIER_UPDATE",
  "PICKING_APP_VIEW": "PICKING_APP_VIEW"
} as any